/**
 * Helpers partagés par les écrans "Transactions" et "Mes remboursements".
 */

export type StatusKind = 'success' | 'danger' | 'pending' | 'neutral';

const SUCCESS = ['confirm', 'success', 'succes', 'complete', 'done', 'valid', 'paid', 'approved'];
const DANGER = ['refus', 'reject', 'fail', 'echec', 'échec', 'error', 'cancel', 'annul', 'declin'];
const PENDING = ['pending', 'attente', 'process', 'cours', 'initi'];

export function statusKind(status?: string | null): StatusKind {
  const s = (status ?? '').toLowerCase();
  if (SUCCESS.some((k) => s.includes(k))) return 'success';
  if (DANGER.some((k) => s.includes(k))) return 'danger';
  if (PENDING.some((k) => s.includes(k))) return 'pending';
  return 'neutral';
}

export function statusLabel(status?: string | null): string {
  switch (statusKind(status)) {
    case 'success':
      return 'Confirmé';
    case 'danger':
      return 'Refusé';
    case 'pending':
      return 'En attente';
    default:
      return status ?? '—';
  }
}

/** 8000 -> "8 000 XOF" */
export function formatAmount(amount: number | string | null | undefined): string {
  const n = Number(amount);
  if (amount === null || amount === undefined || isNaN(n)) return '—';
  return `${n.toLocaleString('fr-FR', { maximumFractionDigits: 0 }).replace(/\u202f|\u00a0/g, ' ')} XOF`;
}

export function dateValue(date?: string | null): number {
  const t = date ? new Date(date).getTime() : 0;
  return isNaN(t) ? 0 : t;
}

export const STATUS_OPTIONS: { value: StatusKind | ''; label: string }[] = [
  { value: '', label: 'Tous les statuts' },
  { value: 'success', label: 'Confirmé' },
  { value: 'danger', label: 'Refusé' },
  { value: 'pending', label: 'En attente' },
];